import 'url-search-params-polyfill';

var DEFAULT_SERVICE = "community";  // by convention

window.authSession.then(function(userInfo) {
  if (userInfo.loginStatus == "Anonymous") {
    var targetNotLogged =
      $(".network-menu .menu-item--login .login-button").length > 0
        ? $(".network-menu .menu-item--login .login-button")
        : $(".mobile-menu .mobile-menu__login");
    targetNotLogged.on("click", () => {
      var continueParamSearch = new URLSearchParams(window.location.search);
      continueParamSearch.delete('nocache');
      var continueParamSearchString = continueParamSearch.toString() ? "?" + continueParamSearch.toString() : "";
      var continueParam = 'continue_url=' + encodeURIComponent(
	window.location.protocol + '//' + window.location.host +
	window.location.pathname + continueParamSearchString
      );
      startLogin(createLoginUrl(continueParam), true);
    });
  } else {
    var username = userInfo.name || userInfo.username;
    if (username.length > 20) {
      username = username.substring(0, 15);
      username += "...";
    }
    var target =
      $(".network-menu .menu-item--login").length > 0
        ? $(".network-menu .menu-item--login")
        : $(".mobile-menu .mobile-menu__login");
        
    var logoutUrl = "/a0logout?redirect=";
    logoutUrl += encodeURIComponent(window.location.href);

    // user profile
    var userProfile = document.createElement("div");
    userProfile.setAttribute("class", "user-profile");

    // user info
    var userInfoContainer = document.createElement("div");
    userInfoContainer.setAttribute("class", "user-info");
    // append user info
    userProfile.appendChild(userInfoContainer);

    // user name
    var userInfoName = document.createElement("div");
    userInfoName.setAttribute("class", "user-info__name");
    userInfoName.innerText = username;
    // append user name
    userInfoContainer.appendChild(userInfoName);

    if (userInfo.avatar) {
      // user picture
      var userPicture = document.createElement("div");
      userPicture.setAttribute("class", "user-picture");
      // append user picture
      userProfile.appendChild(userPicture);

      // user image
      var userImage = document.createElement("img");
      userImage.setAttribute("class", "user-picture__image");
      userImage.setAttribute("src", userInfo.avatar);
      // append user image
      userPicture.appendChild(userImage);
    }

    // user panel
    var userPanel = document.createElement("div");
    userPanel.setAttribute("class", "user-panel");
    // append user panel
    userProfile.appendChild(userPanel);

    // user panel panel link
    var userPanelProfileLink = document.createElement("a");
    userPanelProfileLink.setAttribute("class", "user-panel__link");
    userPanelProfileLink.setAttribute("href", MYQN_ORIGIN + "/dashboard");
    userPanelProfileLink.innerText = "Profilo";
    // append user panel link
    userPanel.appendChild(userPanelProfileLink);


    // user panel logout link
    var userPanelLogoutLink = document.createElement("a");
    userPanelLogoutLink.setAttribute("class", "user-panel__link");
    userPanelLogoutLink.setAttribute("href", logoutUrl);
    userPanelLogoutLink.innerText = "logout";
    // append user panel link
    userPanel.appendChild(userPanelLogoutLink);

    // append template
    target.html(userProfile);
  }
});

function openAndReloadOnClose(url, callback, failureCallback) {
  var win = window.open(url);
  if (win !== null) {
    var timer = setInterval(function() {
      if (win.closed) {
        clearInterval(timer);
        if (typeof callback == "function") callback();
      }
    }, 100);
  } else {
    if (typeof failureCallback == "function") failureCallback();
  }
}

function getEdition() {
  if (typeof MonrifPolopolyUtility !== 'undefined' && 'edizione' in MonrifPolopolyUtility) {
    return MonrifPolopolyUtility.edizione.externalId
  }
}

/**
   * Creates a login url
   *
   * @param {string} extraParams Parameters added to redirect_uri parameter of Auth0 login.
   * @param {boolean} embedMode The login will be shown stand-alone or in iframe?
   * @return {string} Valid URL usable for login.
   */
function createLoginUrl(extraParams, embedMode) {
  var embedMode = false || embedMode;
  var parsedParams = new URLSearchParams(extraParams);  // TODO IE compatibility issue!
  var serviceName = parsedParams.get("primary_service") || DEFAULT_SERVICE;
  var domainName = typeof MonrifPolopolyUtility !== 'undefined'
    ? MonrifPolopolyUtility.site.split(".")[2]
    : "qn";
  extraParams = extraParams || "";
  if (extraParams) extraParams += "&";
  extraParams += "primary_service=";
  extraParams += serviceName;
  extraParams += "&primary_domain=";
  extraParams += domainName;
  var primaryEdition = getEdition();
  if (primaryEdition) {
      extraParams += "&primary_edition=";
      extraParams += primaryEdition;
  }
  var localExtraParams = new URLSearchParams(window.location.search);
  localExtraParams.delete('nocache');
  extraParams = localExtraParams.toString() ? extraParams + "&" + localExtraParams.toString() : extraParams;
  var redirect_url = "https://";
  redirect_url += document.location.host;
  redirect_url += "/a0callback?";
  redirect_url += extraParams ? extraParams : "";

  var url = "https://";
  url += AUTH0_DOMAIN;
  url += "/authorize?";
  // var url = "http://localhost:3004/?";
  url += "client_id=";
  url += AUTH0_CLIENT_ID;
  url += "&response_type=code&connection=";
  url += AUTH0_CONNECTION;
  url += "&scope=openid%20email%20profile&service=";
  url += serviceName;
  url += "&redirect_uri=";
  url += encodeURIComponent(redirect_url);
  if (embedMode) url += "&embed";
  return url;
}

function createCommunityUrl(extraParams) {
  var parsedParams = new URLSearchParams(extraParams);
  if (!parsedParams.continue_url) {
    parsedParams.set('continue_url', window.location.href);
  }
  var primaryEdition = getEdition();
  if (primaryEdition) {
    parsedParams.set('primary_edition', primaryEdition);
  }
  return "/community/iscrizione?" + new URLSearchParams(parsedParams);
}

function startLogin(url, openInTab) {
  if (openInTab) {
    openAndReloadOnClose(url, function() {
      window.location.reload();
    });
  } else {
    window.location.href = url;
  }
}

function resendConfirmEmail(user) {
  var user_id = user.id.match(/[^/]+$/);
  $.post(`${MYQN_ORIGIN}/resend-verification-email?user_id=${user_id}`);
}

function createPendingWidgetInElement(elementSelector, loginButtonHandler) {
  function disableButton(){
    $('.pending').addClass('email--sent');
  }
  window.authSession.then(user => {
    var widget = $('<div class="pending"><div class="pending__image"></div></div');
    var head = $('<h2 class="pending__title">Il tuo indirizzo email non è stato ancora confermato. Controlla la tua email e segui le istruzioni.</h2>');
    
    var resend = $('<div class="pending__email"></div>');
    var resendEmail = $(`<span>${user.email}</span>`);
    var resendEmailButton = $('<a href="#">Invia di nuovo</a>').on("click", ev => {ev.preventDefault(); resendConfirmEmail(user); disableButton()});
    resend.append(resendEmail);
    resend.append(resendEmailButton);

    var loginButton = $('<a href="#newsletter--mailupform">qui</a>').on("click", loginButtonHandler);
    var loginParagraph = $('<p class="pending__description"></p>');

    loginParagraph.append('Ti abbiamo inviato una email di conferma a questo indirizzo, una volta confermata la tua email clicca ', loginButton, ' per continuare.');
    var footer = $('<div class="pending__footer">Se non hai ricevuto email, controlla nello spam.</div>');
    widget.append(head, resend, loginParagraph, footer);
    
    $(elementSelector).after(widget);
  });
}

function createPendingWidget(loginButtonHandler) {
  return createPendingWidgetInElement("#piano-widget", loginButtonHandler);
}

function loginInPage() {
  var pianoWidget = document.querySelector('#piano-widget');
  var frame = document.createElement('iframe');

  frame.src = createLoginUrl('continue_url=' + window.location.href, true);
  frame.id = 'login-frame';
  frame.style.height = '600px';
  frame.style.width = '100%';
  frame.style.border = 'none';

  pianoWidget.style.maxWidth = 'none';
  pianoWidget.style.paddingBottom = '0';
  pianoWidget.appendChild(frame);
  
  var mobileSkin = document.getElementById("speed_mobile_skin");
  if (mobileSkin) mobileSkin.setAttribute("class", "riposiziona");

  window.loginComplete = function() {
    window.location.reload();
  }
}

function receiveLoginComplete(event) {
  if (!event.origin.match(/quotidiano\.net$/) && !event.origin.match(/auth0\.com$/)) {
    return
  }
  if (!event.data.sender || event.data.sender !== "universalLogin") {
    return
  }
  console.debug("message from universal login");
  if (!event.data.event || event.data.event !== "loginComplete") {
    return
  }
  console.debug("login complete");
  if (typeof window.loginComplete === "function") window.loginComplete();
}
window.addEventListener("message", receiveLoginComplete, false);

/*
 * Piano messages handlers
 */
function receiveStartLogin(event) {
  if (!event.origin.match(/tinypass\.com$/)) {
    return
  }
  console.debug("message from tinypass");
  if (!event.data.sender || event.data.sender !== "pianoExperience") {
    return
  }
  console.debug("message from pianoExperience");
  if (!event.data.event || event.data.event !== "startLogin") {
    return
  }
  console.debug("requested login");
  var params = event.data.params || "";
  startLogin(createCommunityUrl((new URLSearchParams(params)).toString()), true);
}
window.addEventListener("message", receiveStartLogin, false);

window.startLogin = startLogin;

window.createLoginUrl = createLoginUrl;

window.openAndReloadOnClose = openAndReloadOnClose;

window.createPendingWidget = createPendingWidget;

window.createPendingWidgetInElement = createPendingWidgetInElement;

window.loginInPage = loginInPage;